import React from 'react';
import { HTMLView } from 'components/atoms/htmlView';

const PropertyData = props => {
  const { data } = props;
  const { item } = data;
  return (
    <div>
      {item &&
        item.map(data => {
          return (
            <div className={'feature-card'}>
              <HTMLView
                tagName={'h3'}
                className={'intro-heading'}
                html={data.heading}
              />
              <HTMLView
                tagName={'p'}
                className={'intro-description'}
                html={data.description}
              />
            </div>
          );
        })}
    </div>
  );
};
export default PropertyData;
